module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_2.059dc336.png";